<template>
  <div>
    <!-- Storage full dialog -->
    <v-dialog v-model="storageFullDialog" width="99%" max-width="480" persistent>
      <v-card>
        <v-col>
          <v-row align="center">
            <v-col cols="auto"><v-icon color="orange" size="40">mdi-database-alert</v-icon></v-col>
            <v-col>
              <div style="font-weight: bold; font-size: 16px">Stockage local plein</div>
              <div style="font-size: 14px; color: grey; margin-top: 4px">
                Synchronisez vos ordres en attente avant de continuer.
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-divider></v-divider>
        <v-col class="px-0 pb-0">
          <v-btn block color="#7986CB" style="color: white; border-radius: 0px; font-weight: bold"
            @click="retrySaveAfterSync" :loading="isLoading">
            <v-icon class="mr-2">mdi-cloud-sync</v-icon>Synchroniser puis continuer
          </v-btn>
          <v-btn block variant="text" style="border-radius: 0px" @click="storageFullDialog = false">Annuler</v-btn>
        </v-col>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isSavedModalOpen" v-if="
      $store.state.oRstoredData &&
      $store.state.oRstoredData.length > 0 &&
      isSavedModalOpen
    " width="99%" max-width="600">
      <v-card>
        <v-col align="center">
          <h2>Liste des ordres à synchroniser</h2>
        </v-col>
        <v-divider></v-divider>
        <v-col align="center">
          <v-table v-if="$store.state.oRstoredData && $store.state.oRstoredData.length > 0">
            <thead>
              <tr>
                <th class="text-left" style="font-weight: bold">Numéro</th>
                <th class="text-left" style="font-weight: bold">Matricule</th>
              </tr>
            </thead>
            <tbody>
              <tr></tr>
              <tr v-for="(item, idx) in $store.state.oRstoredData.reduce((acc, current) => {
                if (
                  !acc.some(
                    (item) =>
                      item.data['N° RAP COMP'] === current.data['N° RAP COMP'] &&
                      item.data['N° MATR INT'] === current.data['N° MATR INT']
                  )
                ) {
                  acc.push(current);
                }
                return acc;
              }, [])" :key="idx">
                <td v-if="item.data['N° RAP COMP'] == undefined">
                  <v-chip color="grey">Numéro pas encore attribué, créé depuis le web</v-chip>
                </td>
                <td v-else>
                  {{ item.data["N° RAP COMP"] }}
                </td>
                <td>{{ item.data["N° MATR INT"] }}</td>
              </tr>
            </tbody>
          </v-table>
        </v-col>
        <v-divider></v-divider>
        <v-btn color="#7986CB" style="color: white; border-radius: 0px; font-weight: bold" :disabled="isLoading"
          @click="sendSavedOrToServer()">
          Synchroniser</v-btn>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isOrVerificationOpen" width="auto">
      <v-card>
        <v-col style="font-weight: bold">
          Ne plus afficher
          <span style="color: red">{{ selectedOrData["N° RAP COMP"] }}</span> sur la
          web-application ?
        </v-col>
        <v-col>
          <v-row justify="center" align="center">
            <v-col cols="6" align="center">
              <v-btn color="#4CAF50" style="color: white" @click="valideSuppresion()">
                Oui
              </v-btn>
            </v-col>
            <v-col cols="6" align="center">
              <v-btn color="#EF5350" style="color: white" @click="isOrVerificationOpen = false">
                Non
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isOrModalOpen" fullscreen persistent>
      <v-card style="overflow: auto; max-height: 90vh" color="rgb(250, 250, 250)">
        <v-col>
          <sav-form @close="closeModal()" :selectedAgency="selectedAgency" :getOrListeAll="getOrListeAll"
            :itemsDataLocal="itemsData" :technicienListe="technicienListe" :agenceListe="agenceListe"
            :clientListe="clientListe" :mainCheckListe="checkListe" :parcListe="parcListe" :stockListe="stockListe"
            :FormData="savForm" :optionsObj="optionsObj" :user="getUserInformation"
            :storageUsage="storageUsage"
            @storage-full="onStorageFull"></sav-form>
        </v-col>
      </v-card>
    </v-dialog>
    <v-card class="mx-1" v-if="isLoading == false">
      <v-col class="pb-2">
        <v-col class="">
          <v-row align="center" justify="center">
            <v-col cols="auto">
              <h3>Liste des interventions</h3>
            </v-col>
            <v-col cols="py-0" v-if="$store.state.oRstoredData && $store.state.oRstoredData.length > 0">
              <v-row justify="left" align="center">
                <v-col cols="auto" class="pt-0">
                  <v-btn size="small" variant="tonal" color="orange" @click="isSavedModalOpen = true"
                    style="font-weight: bold; font-size: 11px">
                    <v-icon size="16" class="mr-1">mdi-cloud-sync</v-icon>
                    {{ $store.state.oRstoredData.length }} OR à sync
                  </v-btn>
                </v-col>
                <v-col cols="12" md="auto" class="pt-0" style="">
                  <div class="" style="font-size: 12px; color: orange; font-weight: bold">
                    Données non synchronisées — risque de perte si déconnexion
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-row align="center" justify="center">
          <v-col class="pr-0" style="text-transform: uppercase">
            <v-select density="compact" bg-color="#ECEFF1" class="mt-2" label="Technicien(s)" variant="outlined"
              clearable :items="techListe" multiple v-model="selectedTech" hide-details></v-select>
          </v-col>
          <v-col class="pl-2" style="text-transform: uppercase">
            <v-select density="compact" bg-color="#ECEFF1" class="mt-2" label="Agence" return-object item-title="ag_nom"
              variant="outlined" clearable :items="agenceListe" v-model="selectedAgency" hide-details></v-select>
          </v-col>
          <v-col cols="auto" class="mt-1" style="position: absolute; top: 5px; right: 0px; display: flex; align-items: center; gap: 6px">
            <!-- Storage indicator -->
            <v-tooltip v-if="storageUsage.quota > 0" location="bottom end" max-width="260">
              <template v-slot:activator="{ props }">
                <div v-bind="props" style="margin-top: 2px; cursor: default">
                  <div style="font-size: 10px; color: grey; text-align: right">
                    <v-icon size="12">mdi-database</v-icon> {{ storageUsage.percent }}%
                  </div>
                  <v-progress-linear
                    :model-value="storageUsage.percent"
                    :color="storageUsage.percent > 85 ? '#F44336' : storageUsage.percent > 60 ? '#FF9800' : '#66BB6A'"
                    height="5" rounded bg-color="#e0e0e0" style="width: 60px"
                  ></v-progress-linear>
                </div>
              </template>
              <div style="font-size: 13px; line-height: 2">
                <div style="font-weight: bold; font-size: 14px; margin-bottom: 2px">Stockage de l'application</div>
                <div><v-icon size="14" color="#EF9A9A">mdi-database-arrow-up</v-icon> Utilisé : <b>{{ formatBytes(storageUsage.usage) }}</b></div>
                <div><v-icon size="14" color="#A5D6A7">mdi-database-check</v-icon> Disponible : <b>{{ formatBytes(storageUsage.quota - storageUsage.usage) }}</b></div>
                <div style="color: rgba(255,255,255,0.5); font-size: 11px">Total alloué : {{ formatBytes(storageUsage.quota) }}</div>
                <template v-if="$store.state.oRstoredData && $store.state.oRstoredData.length > 0">
                  <v-divider style="margin: 6px 0; border-color: rgba(255,255,255,0.25)"></v-divider>
                  <div style="color: #FFCC80"><v-icon size="14" color="#FFCC80">mdi-cloud-sync</v-icon> {{ $store.state.oRstoredData.length }} OR en attente de sync</div>
                  <div style="font-size: 11px; color: rgba(255,255,255,0.5)">Synchroniser libèrera de l'espace</div>
                </template>
              </div>
            </v-tooltip>
            <v-btn variant="flat" color="rgb(92, 107, 192)" style="color: white" @click="openDialog(undefined)" icon
              density="compact" size="40">
              <v-icon size="30"> mdi-plus </v-icon>
            </v-btn>
            <v-btn icon="mdi-refresh" density="compact" style="font-size: 20px" variant="flat" size="40"
              @click="getOrListeAll" class="ml-1"></v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col>
        <v-row>
          <v-col cols="6" class="py-1 pr-1">
            <v-text-field density="compact" bg-color="#ECEFF1" variant="outlined" hide-details v-model="search"
              label="Recherche" clearable></v-text-field>
          </v-col>
          <v-col cols="6" class="py-1 pl-1">
            <v-select density="compact" variant="outlined" bg-color="#ECEFF1" label="Filtrer sur les OR..." multiple
              hide-details v-model="orFilterByStatut" :items="listeStatutToFilter"></v-select>
          </v-col>
        </v-row>
      </v-col>
      <v-col class="pt-1">
        <Vue3EasyDataTable :sort-by="'date_debut_location_TIMESTAMP'" :sort-type="'desc'"
          table-class-name="customize-table" ref="dataTable" :headers="get_tab_header" :items="get_or_liste_filtered"
          style="overflow: auto" :table-height="windowHeight - 305" rows-per-page-message="Ligne par colonne"
          rows-of-page-separator-message="total" empty-message="Aucune intervention trouvé" @click-row="showOr">
          <template #item-Status_devis="item">
            <div align="center" class="pa-1">
              <v-chip v-if="item['Status devis'] == 'Signé'" color="white"
                style="font-weight: bold; background-color: green">
                {{ item["Status devis"] }}
              </v-chip>
              <v-chip v-else-if="item['Status devis'] == 'en cours'" color="white"
                style="font-weight: bold; background-color: #ffa726">
                {{ item["Status devis"] }}
              </v-chip>
              <v-chip v-else style="font-weight: bold">
                {{ item["Status devis"] }}
              </v-chip>
            </div>
          </template>
          <template #item-DATE-RAPPORT="item">
            <v-col>
              {{ formatDate(item["DATE-RAPPORT"], "DD/MM/YYYY") }}
            </v-col>
          </template>
          <template #item-date_debut_location_TIMESTAMP="item">
            <v-col v-if="item.date_debut_location_TIMESTAMP" align="center">
              {{ formatDate(parseInt(item.date_debut_location_TIMESTAMP), "DD/MM/YYYY") }}
            </v-col>
          </template>
          <template #item-date_fin_location_TIMESTAMP="item">
            <v-col v-if="item.date_fin_location_TIMESTAMP" align="center">
              {{ formatDate(parseInt(item.date_fin_location_TIMESTAMP), "DD/MM/YYYY") }}
            </v-col>
          </template>
          <template #item-delete="item">
            <div class="customize-header" align="center">
              <v-btn variant="text" color="#EF5350" density="compact" size="small"
                @click.stop="deleteOr(item)">
                <v-icon size="22">mdi-delete-outline</v-icon>
              </v-btn>
            </div>
          </template>
          <template #item-Statut="item">
            <div style="display: flex; align-items: center; gap: 6px; padding: 4px 2px; flex-wrap: wrap">
              <v-chip size="small"
                :style="{
                  fontWeight: '600',
                  fontSize: '11px',
                  color: 'white',
                  backgroundColor: item.Statut == 140 ? '#EF9A9A' : (item.retour === 'oui' ? '#006064' : '#4CAF50')
                }">
                <span v-if="item.Statut == 140">Cloturé</span>
                <span v-else>En cours<span v-if="item.retour === 'oui'"> RETOUR</span></span>
              </v-chip>
              <v-tooltip
                v-if="oRstoredDataKeys && oRstoredDataKeys.has(item['N° RAP COMP'])"
                text="En attente de synchronisation" location="bottom">
                <template v-slot:activator="{ props }">
                  <v-icon v-bind="props" size="18" color="#FB8C00">mdi-cloud-upload-outline</v-icon>
                </template>
              </v-tooltip>
            </div>
          </template>
        </Vue3EasyDataTable>
      </v-col>
    </v-card>
    <div v-else-if="!orSyncProgress.active" align="center" style="padding-top: 30vh">
      <v-progress-circular class="mt-3" indeterminate size="200" :width="2" color="primary">
        Chargement
      </v-progress-circular>
    </div>
    <!-- Overlay de synchronisation étape par étape (OR) -->
    <div v-if="orSyncProgress.active" style="
        position: fixed; top: 0; left: 0; height: 100%; width: 100vw;
        background-color: rgba(0, 0, 0, 0.55); z-index: 6;
        display: flex; align-items: center; justify-content: center;">
      <v-card width="92%" max-width="430" style="border-radius: 12px; overflow: hidden">
        <div style="background-color: #5C6BC0; color: white" class="pa-3">
          <div style="display: flex; align-items: center; gap: 8px">
            <v-progress-circular indeterminate size="22" width="3" color="white"></v-progress-circular>
            <span style="font-weight: bold; font-size: 16px">Synchronisation des OR</span>
          </div>
          <div style="font-size: 13px; opacity: 0.9; margin-top: 6px">
            Ordre {{ orSyncProgress.current }} / {{ orSyncProgress.total }}
          </div>
          <v-progress-linear
            :model-value="orSyncProgress.total ? (orSyncProgress.current / orSyncProgress.total) * 100 : 0"
            color="white" bg-color="rgba(255,255,255,0.3)" height="6" rounded class="mt-2">
          </v-progress-linear>
        </div>
        <v-col class="pa-3">
          <div style="font-size: 13px; color: #616161; margin-bottom: 10px">
            <v-icon size="16" color="#5C6BC0" class="mr-1">mdi-clipboard-text-outline</v-icon>
            OR <b>{{ orSyncProgress.numero }}</b> · Matricule <b>{{ orSyncProgress.matricule }}</b>
          </div>
          <div v-if="orSyncProgress.steps && orSyncProgress.steps.length === 0"
            style="font-size: 14px; color: #90A4AE; padding: 5px 0">
            {{ orSyncProgress.stepLabel || 'Préparation…' }}
          </div>
          <div v-for="step in orSyncProgress.steps" :key="step.key"
            style="display: flex; align-items: center; gap: 10px; padding: 5px 0">
            <v-progress-circular v-if="step.status === 'active'" indeterminate size="18" width="2"
              color="#5C6BC0"></v-progress-circular>
            <v-icon v-else-if="step.status === 'done'" size="20" color="#66BB6A">mdi-check-circle</v-icon>
            <v-icon v-else size="20" color="#CFD8DC">mdi-circle-outline</v-icon>
            <span :style="{
              fontSize: '14px',
              color: step.status === 'pending' ? '#B0BEC5' : '#37474F',
              fontWeight: step.status === 'active' ? '600' : '400'
            }">{{ step.label }}</span>
          </div>
        </v-col>
      </v-card>
    </div>
  </div>
  <v-snackbar v-model="snackbarData.value" :timeout="2000" style="position: absolute; top: -80px"
    :color="snackbarData.color">
    <div style="font-weight: bold">
      {{ snackbarData.text }}
    </div>
  </v-snackbar>
</template>

<script>
import savHooks from "../hooks/sav";
import SavForm from "./sav-form.vue";
import Vue3EasyDataTable from "vue3-easy-data-table";
import engine from "../core/DataApi";
import moment from "moment";
import { openDB } from "idb";
import { v4 as uuidv4 } from "uuid";

export default {
  setup() {
    const {
      clientListe,
      parcListe,
      stockListe,
      savForm,
      orListe,
      technicienListe,
      agenceListe,
      getOrListeAll,
      getUserInformation,
      checkListe,
      tableHeader,
      techListe,
      saveCopyDataAsMail,
      optionsObj,
      storageUsage,
      updateStorageUsage,
      oRstoredDataKeys,
      orSyncProgress,
      setOrSyncStep,
      finishOrSyncSteps,
      orSyncSetItem,
      orSyncEnd,
    } = savHooks();
    return {
      clientListe,
      parcListe,
      stockListe,
      savForm,
      orListe,
      technicienListe,
      agenceListe,
      getOrListeAll,
      getUserInformation,
      checkListe,
      tableHeader,
      techListe,
      saveCopyDataAsMail,
      optionsObj,
      storageUsage,
      updateStorageUsage,
      oRstoredDataKeys,
      orSyncProgress,
      setOrSyncStep,
      finishOrSyncSteps,
      orSyncSetItem,
      orSyncEnd,
    };
  },
  data() {
    return {
      isLoading: false,
      loadingData: {},
      selectedAgency: undefined,
      snackbarData: {},
      isSavedModalOpen: false,
      selectedTech: [],
      orFilterByStatut: ["130", "retour"],
      listeStatutToFilter: [
        { title: "Cloturé", value: "140" },
        { title: "En cours", value: "130" },
        { title: "Retour", value: "retour" },
      ],
      selectedOrData: undefined,
      isOrVerificationOpen: false,
      itemsData: undefined,
      search: "",
      windowHeight: window.innerHeight,
      isOrModalOpen: false,
      storageFullDialog: false,
      pendingOrData: null,
    };
  },
  watch: {
    agenceListe(val) {
      if (this.selectedAgency == undefined)
        this.selectedAgency = val.find(
          (val) => val.ID_Agence == this.getUserInformation.user_id_agence
        );
    },
  },
  mounted() {
    let query = this.$route.query;
    if (query.search) this.search = query.search;

    this.onResize();
    // this.getOrOptions()
    this.selectedTech = [this.getUserInformation.user_name];
  },
  computed: {
    get_tab_header() {
      let tab_header = this.tableHeader;

      let list = [
        {
          value: "Statut",
          text: "Statut",
          index: -10,
        },
        {
          value: "delete",
          text: "",
          index: 99,
        },
      ];

      tab_header = tab_header.concat(list);

      for (let i = 0; i < tab_header.length; i++) tab_header[i]["sortable"] = true;

      tab_header = tab_header.sort((a, b) => a.index - b.index);

      return tab_header;
    },
    get_or_liste_filtered() {
      let liste = [];
      let tmpOr;

      if (this.selectedAgency == undefined) tmpOr = this.orListe;
      else
        tmpOr = this.orListe.filter(
          (val) => val.ID_Agence == this.selectedAgency.ID_Agence
        );

      if (this.search == undefined || this.search.length == 0) {
        liste = tmpOr;

        for (let i = 0; i < tmpOr.length; i++)
          liste[i]["DATE-RAPPORT"] = tmpOr[i]["DATE RAPPORT"];
      } else {
        for (let i = 0; i < tmpOr.length; i++) {
          let inter = tmpOr[i];
          inter["DATE-RAPPORT"] = inter["DATE RAPPORT"];
          let key =
            inter["N° RAP COMP"] +
            inter["N° MATR INT"] +
            inter["societeliv"] +
            inter["num_contrat"] +
            inter["societeliv"];

          if (key.toUpperCase().includes(this.search.toUpperCase())) liste.push(inter);
        }
      }

      if (this.selectedTech && this.selectedTech.length > 0)
        liste = liste.filter((val) =>
          this.selectedTech.includes(val["Techniciens_Nom(1)"])
        );
      if (this.orFilterByStatut && this.orFilterByStatut.length > 0) {
        let finalListe = [];
        for (let i = 0; i < this.orFilterByStatut.length; i++) {
          let key = this.orFilterByStatut[i];
          if (key == "130") {
            finalListe = finalListe.concat(
              liste.filter((val) => val.Statut == "130" && val.retour == "")
            );
          } else if (key == "140") {
            finalListe = finalListe.concat(
              liste.filter((val) => val.Statut == "140")
            );
          } else if (key == "retour") {
            finalListe = finalListe.concat(
              liste.filter((val) => val.Statut == "130" && val.retour == "oui")
            );
          }
        }
        liste = finalListe;
      }

      liste = liste.sort((a, b) => {
        return moment(b.CREATION).format("x") - moment(a.CREATION).format("x");
      });

      return liste;
    },
  },
  methods: {
    formatBytes(bytes) {
      if (!bytes) return '0 Mo';
      const mb = bytes / (1024 * 1024);
      return mb >= 1 ? `${mb.toFixed(0)} Mo` : `${(bytes / 1024).toFixed(0)} Ko`;
    },
    onStorageFull(pendingData) {
      this.pendingOrData = pendingData;
      this.storageFullDialog = true;
    },
    async retrySaveAfterSync() {
      await this.sendSavedOrToServer();
      await this.updateStorageUsage();
      if (this.pendingOrData) {
        try {
          this.$store.commit('setOrStoredData', this.pendingOrData);
        } catch (e) {
          console.warn('retrySaveAfterSync: impossible de sauvegarder', e);
        }
        this.pendingOrData = null;
        this.closeModal();
      }
      this.storageFullDialog = false;
    },
    async deleteFromBdd(name, bdd) {
      try {
        const db = await openDB("sav-database");

        if (!db.objectStoreNames.contains(bdd)) {
          throw new Error(`Le store "${bdd}" n'existe pas.`);
        }

        await db.delete(bdd, name);
      } catch (err) {
        console.error("❌ Erreur lors de la suppression :", err);
      }
    },
    async getFromBdd(name, key) {
      try {
        const tempDb = await openDB("sav-database");
        tempDb.close();

        const db = await openDB("sav-database");

        const result = await db.get(key, name);
        return result;
      } catch (err) {
        console.error("Erreur dans getFromBdd :", err);
        return null;
      }
    },
    async sendSavedOrToServer() {
      let savedOrList = JSON.parse(JSON.stringify(this.$store.state.oRstoredData));
      this.isLoading = true;
      this.loadingData = {};

      try {
        for (let i = 0; i < savedOrList.length; i++) {
          let ordre = savedOrList[i];
          let functionName = ordre.from;
          let savedData = await this.getFromBdd(ordre.key + "_" + functionName, "synchroData");

          if (savedData) {
            this.loadingData[i] = false;
            let synchroData = JSON.parse(savedData);

            // Affichage étape par étape : prépare la progression de cet OR
            const withEmail = !!(this.optionsObj && this.optionsObj.savedSignature && this.optionsObj.savedSignature.length > 0);
            const hasItems = !!(synchroData.data && synchroData.data.items && synchroData.data.items.length > 0);
            this.orSyncSetItem(i + 1, savedOrList.length, ordre, functionName, withEmail, hasItems);
            this.setOrSyncStep('read');

            if (functionName == "creatOrSAV_FICHE") {
              await this.creatOrSAV_FICHE(
                i,
                synchroData.data.finalObj,
                synchroData.data.itemsData,
                synchroData.data.items,
                synchroData.data.form,
                synchroData.data.isBrouillon,
                synchroData,
                synchroData.data.pdfLink
              );
            } else if (functionName == "editOrSAV_FICHE") {
              await this.editOrSAV_FICHE(
                i,
                synchroData.data.finalObj,
                synchroData.data.itemsData,
                synchroData.data.items,
                synchroData.data.form
              );
            } else if (functionName == "creatOrSAV2") {
              await this.creatOrSAV2(
                i,
                synchroData.data.finalObj,
                synchroData.data.itemsData,
                synchroData.data.items,
                synchroData.data.form,
                synchroData.data.optionsObj,
                undefined,
                synchroData.data.pdfLink
              );
            }
            // Progression synchro : OR terminé, on coche toutes ses étapes
            this.finishOrSyncSteps();
          }
        }

      } catch (err) {
        console.error("Erreur lors de la synchronisation :", err);
        this.snackbarData = { value: true, text: "Erreur lors de la synchronisation", color: "red" };
      } finally {
        this.orSyncEnd(); // masque l'overlay de progression
        this.isLoading = false;
        this.updateStorageUsage();
      }
    },
    async creatOrSAV_FICHE(idx, finalObj, itemsData, items, form, isBrouillon, ordre, pdfLink) {
      return new Promise((resolve) => {
        finalObj["IS_FROM_WEB"] = "oui";

        // Progression synchro : création de la fiche OR
        this.setOrSyncStep('fiche');

        engine.creat_new_or_1(finalObj, async (data) => {
          try {
            if (data.code == 0) {
              let index = this.$store.state.oRstoredData.findIndex(
                (val) => val.data["N° RAP COMP"] == finalObj["N° RAP COMP"]
              );
              if (index > -1) {
                await this.deleteFromBdd(
                  this.$store.state.oRstoredData[index].key + "_creatOrSAV_FICHE",
                  "synchroData"
                );
                this.$store.state.oRstoredData.splice(index, 1);
              }
              this.$store.commit("clearOrStoredDataById", finalObj.id);
              let key = finalObj["id"] + finalObj["N° MATR INT"];
              let photoData = await this.getFromBdd(key, "synchroData");
              if (photoData) form["photos"] = JSON.parse(photoData);
              await this.deleteFromBdd(key, "synchroData");
              this.updateStorageUsage();

              await this.updateDropboxPhotos(idx, data.data.orNum, finalObj, form, pdfLink);

              if (isBrouillon == true) {
                this.closeModal();
                resolve();
                return;
              }

              if (items.length == 0) {
                await this.creatOrSAV2(
                  idx,
                  ordre.data.finalObj,
                  ordre.data.finalObj,
                  ordre.data.items,
                  ordre.data.form,
                  ordre.data.optionsObj,
                  data.data.orNum,
                  pdfLink
                );
                resolve();
                return;
              }

              // Progression synchro : envoi des pièces de la fiche
              this.setOrSyncStep('lignes1');
              for (let i = 0; i < items.length; i++) {
                let moteurInfo = items[i];
                let elem = {
                  id: uuidv4(),
                  "_LINK SAV": finalObj["_LINK MOTEUR"],
                  id_SAV: finalObj.id,
                  "SAV REF PRODUIT": moteurInfo.PIECE_REFERENCE,
                  "SAV DESIGNATION": moteurInfo.PIECE_DESIGNATION,
                  IS_FROM_WEB: moteurInfo.IS_FROM_WEB,
                  "SAV QTE PROD": moteurInfo.qte,
                  "SAV PV UNIT": undefined,
                  PIECE_TOTAL: undefined,
                  FLAG_DELETE: undefined,
                  Index_Ligne: i + 1,
                };
                if (moteurInfo.PM) elem["PM"] = moteurInfo.PM;

                await new Promise((res) => engine.creat_new_moteur_1_line(elem, res));
              }

              await this.creatOrSAV2(
                idx,
                ordre.data.finalObj,
                ordre.data.finalObj,
                ordre.data.items,
                ordre.data.form,
                ordre.data.optionsObj,
                data.data.orNum,
                pdfLink
              );
              resolve();
            } else {
              console.log("OR1 ERROR");
              resolve();
            }
          } catch (err) {
            console.error("creatOrSAV_FICHE exception :", err);
            resolve();
          }
        });
      });
    },
    isValidJSON(str) {
      try {
        const parsed = JSON.parse(str);
        return typeof parsed === "object" && parsed !== null;
      } catch (e) {
        return false;
      }
    },
    async creatOrSAV2(idx, finalObj, itemsData, items, form, optionsObj, orNum, pdfLink) {
      return new Promise((resolve) => {
        let that = this;
        this.loadingData[idx] = true;

        delete finalObj.STATUS_DEVIS;
        finalObj["Status devis"] = "Signé";
        finalObj["Table"] = "SAV_2";
        if (orNum) finalObj["N° RAP COMP"] = orNum;

        // Progression synchro : enregistrement du devis
        this.setOrSyncStep('devis');

        engine.creat_new_or_2(finalObj, async function (data) {
          try {

            if (data.code == 0) {
              let index = that.$store.state.oRstoredData.findIndex(
                (val) => val.data["N° RAP COMP"] == finalObj["N° RAP COMP"]
              );

              if (that.$store.state.oRstoredData && that.$store.state.oRstoredData[index])
                await that.deleteFromBdd(
                  that.$store.state.oRstoredData[index].key + "_creatOrSAV2",
                  "synchroData"
                );

              if (index > -1) that.$store.state.oRstoredData.splice(index, 1);
              that.$store.commit("clearOrStoredDataById", finalObj.id);
              that.updateStorageUsage();

              if (
                that.optionsObj.savedSignature &&
                that.optionsObj.savedSignature.length > 0
              ) {
                let key = finalObj["id"] + finalObj["N° MATR INT"];
                let picsData = await that.getFromBdd(key, "synchroData");
                let pics = undefined;
                if (picsData) pics = JSON.parse(picsData);

                let dataFinded = itemsData == undefined ? finalObj : itemsData

                if (that.optionsObj.sendOnlyRetourOr == undefined || that.optionsObj.sendOnlyRetourOr == 1 || dataFinded["retour"] == 'oui') {
                  // Progression synchro : envoi de la copie par e-mail
                  that.setOrSyncStep('email');
                  that.saveCopyDataAsMail(
                    pdfLink,
                    pics,
                    dataFinded
                  );
                } else {
                  console.log("dont't send mail !!");
                }
              }

              if (
                itemsData &&
                itemsData.CARA_MATERIEL &&
                that.isValidJSON(itemsData.CARA_MATERIEL)
              ) {
                let jsonInfo = JSON.parse(itemsData.CARA_MATERIEL);

                if (form["equipement"] == undefined) form["equipement"] = [];

                let matricule = undefined;

                if (form.materiel && form.materiel.MATRICULE)
                  matricule = form.materiel.MATRICULE;
                else matricule = form.materielMatricul;

                if (
                  optionsObj.auto_creat_etatdl &&
                  optionsObj.auto_creat_etatdl == "1" &&
                  jsonInfo &&
                  jsonInfo.NUM_CONTRAT
                ) {
                  engine.show_etadl(
                    jsonInfo.NUM_CONTRAT,
                    form["equipement"],
                    matricule,
                    itemsData.CARA_MATERIEL,
                    itemsData.id,
                    optionsObj.show_equipement_in_etadl == 1,
                    itemsData.Message_Interne,
                    function () { }
                  );
                }
              }

              if (Object.keys(that.$store.state.oRstoredData).length == 0)
                that.getOrListeAll();

              if (items.length == 0) {
                resolve();
                return;
              }

              // Progression synchro : envoi des pièces du devis
              that.setOrSyncStep('lignes2');
              let created = 0;
              for (let i = 0; i < items.length; i++) {
                let moteurInfo = items[i];
                let elem = {
                  id: moteurInfo.id,
                  "_LINK SAV": itemsData["_LINK MOTEUR"],
                  id_SAV: itemsData["id"],
                  "SAV REF PRODUIT": moteurInfo.PIECE_REFERENCE,
                  "SAV DESIGNATION": moteurInfo.PIECE_DESIGNATION,
                  IS_FROM_WEB: moteurInfo.IS_FROM_WEB,
                  "SAV QTE PROD": moteurInfo.qte,
                  "SAV PV UNIT": undefined,
                  PIECE_TOTAL: undefined,
                  FLAG_DELETE: undefined,
                  Index_Ligne: i + 1,
                };

                if (moteurInfo && moteurInfo["PM"]) elem["PM"] = moteurInfo.PM;

                engine.creat_new_moteur_2_line(elem, function () {
                  created++;
                  if (created === items.length) resolve();
                });
              }
            } else {
              resolve();
            }
          } catch (err) {
            console.error("creatOrSAV_FICHE exception :", err);
            resolve();
          }
        });
      });
    },
    async editOrSAV_FICHE(idx, finalObj, itemsData, items, form) {
      return new Promise((resolve) => {
        let that = this;

        // Progression synchro : mise à jour de l'OR
        this.setOrSyncStep('fiche');

        engine.edit_or(finalObj, async function (data) {
          try {

            if (data.code == 0) {

              let index = that.$store.state.oRstoredData.findIndex(
                (val) => val.data["N° RAP COMP"] == finalObj["N° RAP COMP"]
              );

              if (
                index > -1 &&
                that.$store &&
                that.$store.state &&
                that.$store.state.oRstoredData &&
                that.$store.state.oRstoredData[index]
              )
                await that.deleteFromBdd(
                  that.$store.state.oRstoredData[index].key + "_editOrSAV_FICHE",
                  "synchroData"
                );

              if (
                index > -1 &&
                that.$store &&
                that.$store.state &&
                that.$store.state.oRstoredData &&
                that.$store.state.oRstoredData[index]
              )
                that.$store.state.oRstoredData.splice(index, 1);

              that.$store.commit("clearOrStoredDataById", finalObj.id);
              let key = itemsData["id"] + finalObj["N° MATR INT"];
              let picData = await that.getFromBdd(key, "synchroData");
              if (picData) form["photos"] = JSON.parse(picData);
              await that.deleteFromBdd(key, "synchroData");
              that.updateStorageUsage();

              await that.updateDropboxPhotos(idx, data.data.orNum, itemsData, form, undefined);

              engine.delete_old_moteur_by_link(finalObj["_LINK MOTEUR"], function () {
                if (Object.keys(that.$store.state.oRstoredData).length == 0)
                  that.getOrListeAll();

                const eligibleItems = items.filter(
                  (m) => m["IS_FROM_WEB"] == "OUI" || m["IS_FROM_WEB"] == "oui" || m["IS_FROM_WEB"] == ""
                );

                if (eligibleItems.length == 0) {
                  resolve();
                  return;
                }

                // Progression synchro : envoi des pièces
                that.setOrSyncStep('lignes');
                let created = 0;
                for (let i = 0; i < eligibleItems.length; i++) {
                  let moteurInfo = eligibleItems[i];

                  let id = moteurInfo.id;
                  if (moteurInfo["IS_FROM_WEB"] == "OUI" || moteurInfo["IS_FROM_WEB"] == "oui")
                    id = uuidv4();

                  let elem = {
                    id: id,
                    "_LINK SAV": finalObj["_LINK MOTEUR"],
                    id_SAV: itemsData.id,
                    "SAV REF PRODUIT": moteurInfo.PIECE_REFERENCE,
                    "SAV DESIGNATION": moteurInfo.PIECE_DESIGNATION,
                    "SAV QTE PROD": moteurInfo.qte,
                    "SAV PV UNIT": undefined,
                    PIECE_TOTAL: undefined,
                    FLAG_DELETE: undefined,
                    IS_FROM_WEB: "OUI",
                    Index_Ligne: i + 1,
                  };

                  if (moteurInfo.PM) elem["PM"] = moteurInfo.PM;

                  engine.creat_new_moteur_1_line(elem, function () {
                    created++;
                    if (created === eligibleItems.length) resolve();
                  });
                }
              });
            } else {
              console.log("EDIT ERROR");
              resolve();
            }
          } catch (err) {
            console.error("creatOrSAV_FICHE exception :", err);
            resolve();
          }
        });
      });
    },
    updateDropboxPhotos(idx, num, itemsData, form, pdfLink) {
      return new Promise((resolve) => {
        let orNum = num || (itemsData && itemsData["N° RAP COMP"]);

        // Progression synchro : envoi des photos et du PDF
        this.setOrSyncStep('photos');

        if (!form["photos_loaded"] || !orNum) {
          resolve();
          return;
        }

        if (pdfLink) {
          engine.file_upload_with_ext(
            pdfLink, orNum,
            "Recap - " + moment().format("DD-MM-YYYY HHhmm") + ".pdf",
            () => { }
          );
        }

        engine.photo_folder_liste(orNum, (data) => {
          const existingFiles = data.code == 0 && data.data?.length > 0 ? data.data : [];

          if (existingFiles.length > 0) {
            let deleted = 0;
            for (let file of existingFiles) {
              engine.photo_delete(orNum, file, () => {
                deleted++;
                if (deleted === existingFiles.length) {
                  this.updateDropboxPhotos(idx, num, itemsData, form, pdfLink).then(resolve);
                }
              });
            }
          } else if (form["photos"]?.length > 0) {
            let uploaded = 0;
            for (let i = 0; i < form["photos"].length; i++) {
              engine.file_upload(
                form["photos"][i], orNum,
                i + 1 + " - " + moment().format("DD-MM-YYYY HHhmm"),
                () => {
                  uploaded++;
                  if (uploaded >= form["photos"].length) resolve();
                }
              );
            }
          } else {
            resolve();
          }
        });
      });
    },
    valideSuppresion() {
      let that = this;
      if (this.selectedOrData.Table == "SAV_FICHE") {
        engine.delete_or_by_id(
          this.selectedOrData["N° RAP COMP"],
          this.selectedOrData["id"],
          function () {
            that.getOrListeAll();
            that.selectedOrData = undefined;
          }
        );
      } else {
        engine.delete_or2_by_id(
          this.selectedOrData["N° RAP COMP"],
          this.selectedOrData["id"],
          function () {
            that.getOrListeAll();
            that.selectedOrData = undefined;
          }
        );
      }
      this.isOrVerificationOpen = false;
    },
    showOr(orData) {
      if (
        this.$store.state &&
        this.$store.state.oRstoredData &&
        this.$store.state.oRstoredData.find(
          (val) =>
            val.data["N° MATR INT"] == orData["N° MATR INT"] &&
            val.data["N° RAP COMP"] == orData["N° RAP COMP"]
        )
      ) {
        this.snackbarData = {
          value: true,
          text: "L'orde est en attente de synchronisation et n'est plus modifiable.",
          color: "red",
        };
      } else {
        if (this.isOrVerificationOpen == false) this.openDialog(orData);
      }
    },
    deleteOr(orData) {
      this.isOrVerificationOpen = true;
      this.selectedOrData = orData;
    },
    closeModal() {
      this.isOrModalOpen = false;
    },
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    openDialog(data) {
      this.itemsData = data;
      this.isOrModalOpen = true;
    },
    formatDate(date, form) {
      let tmpDate = moment(date).format(form);
      if (tmpDate == "Invalid date") tmpDate = undefined;
      return tmpDate;
    },
  },
  components: {
    SavForm,
    Vue3EasyDataTable,
  },
};
</script>

<style>
/* Thème du tableau OR — identité INDIGO conservée, version modernisée
   (en-tête indigo doux, lignes claires, zébrage léger, survol indigo). */
.customize-table {
  --easy-table-border: 1px solid #e4e7f2;
  --easy-table-row-border: 1px solid #eceef7;

  --easy-table-header-font-size: 13px;
  --easy-table-header-font-weight: 700;
  --easy-table-header-height: 48px;
  --easy-table-header-font-color: #303f9f;
  --easy-table-header-background-color: #e8eaf6;

  --easy-table-body-even-row-font-color: #2b2f45;
  --easy-table-body-even-row-background-color: #f4f5fc;

  --easy-table-body-font-weight: 600;
  --easy-table-body-row-font-color: #2b2f45;
  --easy-table-body-row-background-color: #ffffff;
  --easy-table-body-row-height: 46px;
  --easy-table-body-row-font-size: 12px;

  --easy-table-body-row-hover-font-color: #1a237e;
  --easy-table-body-row-hover-background-color: #eef0fb;

  --easy-table-footer-background-color: #e8eaf6;
  --easy-table-footer-font-color: #303f9f;
  --easy-table-footer-font-size: 13px;
  --easy-table-footer-padding: 0px 10px;
  --easy-table-footer-height: 48px;

  --easy-table-rows-per-page-selector-width: 70px;
  --easy-table-rows-per-page-selector-option-padding: 10px;
  --easy-table-rows-per-page-selector-z-index: 1;

  --easy-table-loading-mask-background-color: #eceff1;

  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(48, 63, 159, .08);
}
</style>
